<template>
    <li class="nav-item nav-item--user" @mouseover="add" @mouseleave="remove">
        <a class="nav-link"
           id="customer-account-link"
           :href="href"
           @click.prevent="click">
            <span v-if="logged" class="nav-link-text">{{ user?.first_name }}</span>
            <span v-else class="nav-link-text">Войти</span>
        </a>
        <div v-if="logged" class="nav-wrap">
            <ul class="navbar-user--signin">
                <li class="nav-item"><a class="nav-link" href="/account/profile">Профиль</a></li>
                <li class="nav-item"><a class="nav-link" href="/account/orders">Заказы</a></li>
                <li class="nav-item"><a class="nav-link" href="/account/reviews/company">Отзывы</a></li>
                <li class="divider"></li>
                <li class="nav-item">
                    <span class="nav-link" @click.prevent="$root.logout()">Выйти</span>
                </li>
            </ul>
        </div>
    </li>
</template>

<script>
    import { mapState, mapMutations } from 'vuex';
    export default {
        props: {
            user: Object|null,
            isLogged: {
                type: Boolean,
                required: true
            },
        },
        mounted () {
            this.setLogged(this.isLogged);
        },
        data () {
            return {
                active: false,
                url: '/account/profile',
            };
        },
        methods: {
            ...mapMutations('auth', [
                'setLogged',
                'showModal',
            ]),
            add () {
                if (this.logged) {
                    this.active = true;

                    document.getElementsByClassName("nav-item--user")[0]
                        .classList
                        .add("active");

                    document.getElementsByTagName('body')[0]
                        .classList
                        .add("menu-icons-open");
                }
            },
            remove () {
                if (this.logged) {
                    this.active = false;

                    document.getElementsByClassName("nav-item--user")[0]
                        .classList
                        .remove("active");

                    document.getElementsByTagName('body')[0]
                        .classList
                        .remove("menu-icons-open");
                }
            },
            getToken () {
                return document.querySelector('meta[name="csrf-token"]').getAttribute('content');
            },
            click () {
                if (this.logged) {
                    window.location.href = this.url;
                } else {
                    this.showModal();
                }
            }
        },
        computed: {
            ...mapState('auth', ['logged']),
            href () {
                return this.logged ? this.url : '#';
            }
        },
    }
</script>
